<template>
    <transition
        enter-active-class="l-ss-c-collapse-enter-active"
        leave-active-class="l-ss-c-collapse-leave-active"
        @before-enter="beforeEnter"
        @enter="enter"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
        @leave="leave"
        @after-leave="afterLeave">
        <slot></slot>
    </transition>
</template>

<script>
    export default {
        methods: {
            beforeEnter(element) {
                requestAnimationFrame(() => {
                    if (!element.style.height) {
                        element.style.height = '0px';
                        this.$emit('change-size', element.scrollHeight);
                    }
                    element.style.display = null;
                });
            },
            enter(element) {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        element.style.height = `${element.scrollHeight}px`;
                    });
                });
            },
            afterEnter(element) {
                element.style.height = null;
            },
            beforeLeave(element) {
                requestAnimationFrame(() => {
                    if (!element.style.height) {
                        const currentHeight = element.offsetHeight;
                        element.style.height = `${currentHeight}px`;
                        this.$emit('change-size', -currentHeight);
                    }
                });
            },
            leave(element) {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        element.style.height = '0px';
                    });
                });
            },
            afterLeave(element) {
                element.style.height = null;
            },
        },
    };

</script>

<style scoped>

</style>
